import { API_NODE_BASE } from 'constants';
import { put, get, post, putFile, destroy } from './index';

export const updateBooking = ({ bookingId, data }) => {
  return put(`/bookings/${bookingId}`, data);
};

export const submitBooking = ({ bookingId, submitParams }) => {
  return post(`/bookings/${bookingId}/submit`, submitParams);
};

export const getBookingById = ({ bookingId }) => {
  if (!bookingId) {
    return Promise.resolve(null);
  }
  return get(`/bookings/${bookingId}`, {
    baseURL: `${API_NODE_BASE}/api/v2`,
  });
};

export const getBookingMarginBreakdown = ({ bookingId }) => {
  if (!bookingId) {
    return Promise.resolve(null);
  }
  return get(`/bookings/${bookingId}/margin-breakdown`);
};

export const getBookings = ({ filters }) => {
  return post(`/bookings/list`, filters);
};

export const getPartners = ({ filters }) => {
  return post(`/bookings/partners`, filters);
};

export const getBookingDocuments = ({ bookingId }) =>
  get(`/bookings/${bookingId}/documents`);

export const getBookingDocument = ({ bookingId, documentId }) =>
  get(
    `/bookings/${bookingId}/documents/${documentId}`,
    { responseType: 'blob' },
    false,
  );

export const createBookingDocument = ({ bookingId, data }) =>
  putFile(`/bookings/${bookingId}/documents`, data);

export const getBookingMessages = ({ bookingId }) =>
  get(`/bookings/${bookingId}/messages`);

export const createBookingMessage = ({ bookingId, data }) =>
  put(`/bookings/${bookingId}/messages`, data);

export const getBookingHistories = ({ bookingId }) => {
  return get(`bookings/${bookingId}/histories`);
};

export const getAutoConfirmableBookingsCount = ({
  autoConfirmDays,
  organizationId,
  skip = false,
}) => {
  if (skip) {
    return Promise.resolve({ data: 0 });
  }

  return get(
    `bookings/auto-confirmable/count/${autoConfirmDays}${
      organizationId ? `/organizationId=${organizationId}` : ''
    }`,
  );
};

export const autoConfirmBookings = ({ data }) => {
  if (!data?.autoConfirmDays) {
    return Promise.resolve(null);
  }

  return post('bookings/auto-confirmation', data);
};

export const cancelExtraBooked = ({ experienceCompositionExtraId }) => {
  return destroy(`/experiences/extras/${experienceCompositionExtraId}`);
};

export const updateExperienceCompostionExtra = ({
  experienceCompostionExtraId,
  body,
}) => {
  return put(
    `/experiences/extras/${experienceCompostionExtraId.toString()}`,
    body,
  );
};
